import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
import { getInitiativePage } from '../../../../helpers/breadcrumbRouteHelpers.js';
import { DropdownButton, Modal } from 'react-bootstrap';
import Time from 'react-time';
import { pushRoute } from '../../../../lib/router.js';
import TemplatesContainer from '../../../../containers/change-insights/templates/TemplatesContainer.jsx';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { calculatePercentage } from '../../../../lib/utils.js';
import {
  isDataExist,
  validateEditorData,
} from '../../../editor/defaultOptions.js';
import PageHeader from '../../PageHeader.js';
import RatingLabel from '../../../RatingLabel.jsx';
import SubHeader from '../../../SubHeader.jsx';
import AuthorizedAction from '../../../AuthorizedAction.js';
import VerticalSeparator from '../../../VerticalSeparator.jsx';
import {
  InitiativeLink,
  PortfolioInfoLink,
  ProjectLink,
  ProjectsLink,
} from '../../../links/index.jsx';
import InitiativeTabs from '../../../initiatives/InitiativeTabs.jsx';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import ProjectIcon from '../../../icons/ProjectIcon.jsx';
import { BoardIcon } from '../../../icons/BoardIcon.jsx';
import { LeadIcon } from '../../../icons/LeadIcon.jsx';
import { ClockIcon } from '../../../icons/ClockIcon.jsx';
import { deleteInitiative } from '../../../../modules/initiatives.js';
import styles from './InitiativeHeader.module.css';
import { selectOrganization } from '../../../../modules/organizations.js';
import { EditBlueIcon } from '../../../icons/EditBlueIcon.jsx';
import { DeleteBlueIcon } from '../../../icons/DeleteBlueIcon.jsx';
import { TemplateBlueIcon } from '../../../icons/TemplateBlueIcon.jsx';
import PortfolioIcon from '../../../icons/PorfolioIcon.jsx';
import ParentPortfolioIcon from '../../../icons/ParentPorfolioIcon.jsx';

import Editor from '../../../editor/editor.jsx';
import CustomMenuItem from '../../../CustomMenuItem.jsx';
import { DuplicateIcon } from '../../../icons/DuplicateIcon.jsx';
import DuplicateInitiativeModal from '../../../initiatives/duplicate/DuplicateInitiativeModal.jsx';
import {
  canDuplicateInitiative,
  duplicationText,
} from '../../../../constants/initiativeDuplication.js';
import {
  retrieveProjects,
  selectProjects,
  selectRetrieveProjectsState,
} from '../../../../modules/projects.js';

const mapStateToProps = (state) => ({
  organization: selectOrganization(state),
  projects: selectProjects(state),
  projectsLoaded: selectRetrieveProjectsState(state).success,
});

const mapDispatchToProps = (dispatch, { initiative }) =>
  bindActionCreators(
    {
      deleteInitiative: () => deleteInitiative(initiative.type, initiative.id),
      retrieveProjects,
    },
    dispatch
  );

class InitiativeHeader extends React.PureComponent {
  state = {
    showModal: false,
    showTemplateModal: false,
    showDuplicateModal: false,
  };

  // Duplicate is offered when the user may create this initiative type in some project
  componentDidMount() {
    if (!this.props.projectsLoaded) {
      this.props.retrieveProjects().catch(() => {});
    }
  }

  handleDuplicateShow = () => this.setState({ showDuplicateModal: true });

  handleDuplicateClose = () => this.setState({ showDuplicateModal: false });

  // Only saved initiatives can be duplicated
  canDuplicate = () =>
    !this.props.initiative.draft &&
    canDuplicateInitiative(
      this.props.initiative.type,
      this.props.initiative.project,
      this.props.projects
    );

  handleClose = () => this.setState({ showModal: false });

  handleShow = (event) => {
    event.preventDefault();
    this.setState({ showModal: true });
  };

  navigateToProject = () =>
    pushRoute('projects/show', { projectId: this.props.initiative.project.id });

  navigateToEdit = () =>
    pushRoute('initiatives/edit', {
      initiativeType: this.props.initiative.type,
      initiativeId: this.props.initiative.id,
    });

  handleTemplateClose = () => this.setState({ showTemplateModal: false });

  handleInitiativeDelete = () => {
    const { deleteInitiative } = this.props;

    if (
      window.confirm(
        `Are you sure you want to delete this ${getOrgTermsContent('initiative')}?`
      )
    ) {
      deleteInitiative().then(() => this.navigateToProject());
    }
  };

  handleTemplateShow = (event) => {
    event.preventDefault();
    this.setState({ showTemplateModal: true });
  };

  isAuthorizedManage = (type) =>
    this.props.initiative.project[
      `manage${type.charAt(0).toUpperCase() + type.slice(1)}Initiatives`
    ];

  renderContentButton = () => {
    const {
      initiative: { category, content },
    } = this.props;
    return (
      <React.Fragment>
        <a
          className={`strong ${category.archived ? 'text-muted' : ''}`}
          href="components/headers/PageHeaders/Initiative/InitiativeHeader#"
          onClick={this.handleShow}
        >
          {category.name}
        </a>
        <Modal show={this.state.showModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{category.name} Content</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Editor
              options={{
                holder: 'content-initiative-editor',
                readOnly: true,
                minHeight: 0,
              }}
              data={validateEditorData(content)}
            />
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </React.Fragment>
    );
  };

  renderTemplateSubHeader = () => (
    <SubHeader flexJustify small>
      <h2>
        Overview:&nbsp;
        {this.props.initiative.title}
      </h2>
      {this.props.initiative &&
      (this.props.initiative.project.manageProjectEntities ||
        this.canDuplicate()) ? (
        <div className="actions">
          <DropdownButton
            noCaret
            title=""
            id={this.props.initiative.id}
            className="btn-more btn btn-default"
          >
            {this.isAuthorizedManage(this.props.initiative.type) ? (
              this.props.initiative.project.archived ? (
                <React.Fragment>
                  <CustomMenuItem
                    onClick={() =>
                      window.alert(getOrgTermsContent('archivedProjectMessage'))
                    }
                  >
                    <span className="flex">
                      <EditBlueIcon />
                      <span>&nbsp; Edit</span>
                    </span>
                  </CustomMenuItem>
                  <CustomMenuItem divider />
                </React.Fragment>
              ) : (
                <AuthorizedAction
                  action="update"
                  subject={`${this.props.initiative.type}Initiative`}
                >
                  <CustomMenuItem onClick={this.navigateToEdit}>
                    <span className="flex">
                      <EditBlueIcon />
                      <span>&nbsp; Edit</span>
                    </span>
                  </CustomMenuItem>
                  <CustomMenuItem divider />
                </AuthorizedAction>
              )
            ) : null}

            {/* Copying out of an archived project is allowed */}
            {this.canDuplicate() ? (
              <React.Fragment>
                <CustomMenuItem onClick={this.handleDuplicateShow}>
                  <span className="flex">
                    <DuplicateIcon />
                    <span>&nbsp; {duplicationText('menuItem')}</span>
                  </span>
                </CustomMenuItem>
                <CustomMenuItem divider />
              </React.Fragment>
            ) : null}

            {this.isAuthorizedManage(this.props.initiative.type) ? (
              this.props.initiative.project.archived ? (
                <AuthorizedAction
                  action="update"
                  subject={`${this.props.initiative.type}Initiative`}
                >
                  <CustomMenuItem
                    onClick={() =>
                      window.alert(getOrgTermsContent('archivedProjectMessage'))
                    }
                  >
                    <span className="flex">
                      <DeleteBlueIcon />
                      <span>&nbsp; Delete</span>
                    </span>
                  </CustomMenuItem>
                  <CustomMenuItem divider />
                </AuthorizedAction>
              ) : (
                <AuthorizedAction
                  action="update"
                  subject={`${this.props.initiative.type}Initiative`}
                >
                  <CustomMenuItem onClick={this.handleInitiativeDelete}>
                    <span className="flex">
                      <DeleteBlueIcon />
                      <span>&nbsp; Delete</span>
                    </span>
                  </CustomMenuItem>
                  <CustomMenuItem divider />
                </AuthorizedAction>
              )
            ) : null}
            <AuthorizedAction action="read" subject="linkedFileTemplate">
              <CustomMenuItem onClick={this.handleTemplateShow}>
                <span className="flex">
                  <TemplateBlueIcon />
                  <span>&nbsp; View Templates</span>
                </span>
              </CustomMenuItem>
            </AuthorizedAction>
          </DropdownButton>
        </div>
      ) : null}

      <React.Fragment>
        <Modal
          show={this.state.showTemplateModal}
          onHide={this.handleTemplateClose}
        >
          <Modal.Body>
            <TemplatesContainer
              isArchivedProject={this.props.initiative.project.archived}
            />
          </Modal.Body>
        </Modal>
        {this.state.showDuplicateModal ? (
          <DuplicateInitiativeModal
            show
            initiative={this.props.initiative}
            project={this.props.initiative.project}
            onHide={this.handleDuplicateClose}
          />
        ) : null}
      </React.Fragment>
    </SubHeader>
  );

  render() {
    const {
      initiative: {
        lead,
        type,
        title,
        category,
        impact,
        startDate,
        endDate,
        completionTracked,
        mandatory,
        content,
        participationCount,
        participationCompletedCount,
        project,
      },
      hideSubHeader,
      portfolio,
    } = this.props;

    const datesAreDifferent = startDate ? !startDate.isSame(endDate) : false;

    const pathname = this.props.location?.pathname || window.location.pathname;
    const contentProject = getOrgTermsContent('project');
    const pageType = getInitiativePage(pathname);

    const isShowPage = pageType === 'show';
    const isStudioPage = pageType === 'change-insights';
    const isAnalysisPage = pageType === 'change-insights-analysis';
    const isFilesPage = pageType === 'files';

    return (
      <React.Fragment>
        <PageHeader
          large={false}
          navigation={<InitiativeTabs initiative={this.props.initiative} />}
        >
          <div className={`flex ${styles.flexJustify}`}>
            <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
              <ProjectsLink>{contentProject}</ProjectsLink>
              <ProjectLink projectId={project.id}>{project.name}</ProjectLink>

              {isShowPage ? <span>{this.props.initiative.title}</span> : null}

              {isStudioPage || isAnalysisPage || isFilesPage ? (
                <InitiativeLink initiative={this.props.initiative}>
                  {this.props.initiative.title}
                </InitiativeLink>
              ) : null}

              {isStudioPage ? <span>ChangeInsights Studio</span> : null}
              {isAnalysisPage ? <span>ChangeInsights Analysis</span> : null}

              {isFilesPage ? <span>Linked files</span> : null}
            </BreadCrumbs>
          </div>
        </PageHeader>
        {!hideSubHeader && (
          <React.Fragment>
            {this.renderTemplateSubHeader()}
            <div
              className="component component-bg-white"
              style={{ paddingBottom: '6px' }}
            >
              <div className="flex m-b-20">
                {this.props.organization &&
                this.props.organization.hasParentPortfolios ? (
                  <React.Fragment>
                    <div className="flex header-item">
                      <ParentPortfolioIcon />
                      <strong className="text-muted m-r-12 m-l-8">
                        {getOrgTermsContent('parentPortfolio')}:{' '}
                      </strong>
                      <strong>
                        {this.props.initiative.project.parentPortfolioName ||
                          '—'}
                      </strong>
                    </div>
                    <VerticalSeparator />
                  </React.Fragment>
                ) : null}
                <div className="flex header-item">
                  <PortfolioIcon />
                  <strong className="text-muted m-r-12 m-l-8">
                    {getOrgTermsContent('portfolio')}:{' '}
                  </strong>
                  <strong>
                    {portfolio ? (
                      <PortfolioInfoLink portfolioId={portfolio.id}>
                        {portfolio.name}
                      </PortfolioInfoLink>
                    ) : (
                      '—'
                    )}
                  </strong>
                </div>
                <VerticalSeparator />
                <div className="flex m-l-20">
                  <ProjectIcon />
                  <strong className="text-muted m-l-8 m-r-12">
                    {contentProject}:
                  </strong>
                  <ProjectLink projectId={project.id}>
                    {project.name}
                  </ProjectLink>
                </div>
              </div>

              <div className="flex flex-wrap">
                <div className="flex m-b-20">
                  <BoardIcon />
                  <strong className="text-muted m-l-8 m-r-12 text-capitalize">
                    {type}:
                  </strong>
                  <strong>{title}</strong>
                  <VerticalSeparator customClasses="m-l-18 m-r-18" />
                </div>

                <div className="flex m-b-20">
                  <LeadIcon />
                  <strong className="text-muted m-l-8 m-r-12">Lead:</strong>
                  <strong>{lead}</strong>
                  <VerticalSeparator customClasses="m-l-18 m-r-18" />
                </div>

                <div className="flex m-b-20">
                  <ClockIcon />
                  <strong className="text-muted m-l-8 m-r-12">
                    {datesAreDifferent ? 'Dates' : 'Date'}:
                  </strong>
                  <strong>
                    <Time value={startDate} format="M/D/YY" />
                  </strong>
                  {datesAreDifferent && (
                    <strong>
                      <span>&nbsp;- </span>
                      <Time value={endDate} format="M/D/YY" />
                    </strong>
                  )}
                </div>
              </div>

              <div className="flex flex-wrap">
                <div className="flex m-b-20">
                  <strong className="text-muted m-r-12">Category: </strong>
                  {content && isDataExist(validateEditorData(content)) ? (
                    this.renderContentButton()
                  ) : (
                    <strong
                      className={`text-capitalize ${category.archived ? 'text-muted' : ''}`}
                    >
                      {category.name}
                    </strong>
                  )}
                  <VerticalSeparator customClasses="m-l-18 m-r-18" />
                </div>

                <div className="flex m-b-20">
                  <strong className="text-muted m-r-12">Impact:</strong>
                  <strong>
                    <RatingLabel rating={impact} reverse />
                  </strong>
                  <VerticalSeparator customClasses="m-l-18 m-r-18" />
                </div>

                {(completionTracked || mandatory || content) && (
                  <React.Fragment>
                    {completionTracked ? (
                      <div className="flex m-b-20">
                        <strong className="text-muted m-r-12">
                          Completion:
                        </strong>
                        <strong className="text-capitalize">
                          {completionTracked &&
                            `${calculatePercentage(
                              participationCompletedCount,
                              participationCount
                            )}%`}
                        </strong>
                        <VerticalSeparator customClasses="m-l-18 m-r-18" />
                      </div>
                    ) : null}
                    {completionTracked || mandatory ? (
                      <div className="flex m-b-20">
                        <strong className="text-muted m-r-12">
                          Tracking:{' '}
                        </strong>
                        {mandatory && (
                          <strong className="text-capitalize">Mandatory</strong>
                        )}
                        {mandatory && completionTracked && (
                          <span>, &nbsp;</span>
                        )}
                        {completionTracked && (
                          <strong className="text-capitalize">Tracking</strong>
                        )}
                      </div>
                    ) : null}
                  </React.Fragment>
                )}
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const ConnectedInitiativeHeader = connect(
  mapStateToProps,
  mapDispatchToProps
)(InitiativeHeader);

// Wrapper to inject location from React Router
const InitiativeHeaderWithLocation = (props) => {
  const location = useLocation();
  return <ConnectedInitiativeHeader {...props} location={location} />;
};

export default InitiativeHeaderWithLocation;
